const cbor = require('cbor');
const cobs = require('cobs');

const OnionRpcMethods = [{
    name: 'GetMenuStack',
    value: 1,
    parameter: [],
    response: [
      { name: 'Menu', types: ['Array'], children: [
        { name: 'Menu-Index', types: ['UINT'], },
        { name: 'Line-Index', types: ['UINT', 'null'], },
        { name: 'Cursor-Index', types: ['UINT'], },
      ]},
    ],
  }, {
    name: 'GetMenuLines',
    value: 2,
    parameter: [],
    response: [
      { name: 'Menu-Index', types: ['UINT'] },
      { name: 'Line-Index', types: ['UINT', 'null'] },
      { name: 'Cursor-Index', types: ['UINT'] },
      { name: 'Lines', types: ['Array'], children: [
        { name: 'Line', types: ['Array'], children: [
          { name: 'Konstant-Text', types: ['String'] },
          { name: 'TextRef-Text', types: ['String', 'null'] },
          { name: 'ValueRef-Text', types: ['String'] },
          { name: 'ValueRef-ValueId', types: ['INT'] },
          { name: 'ExtraRef-ValueId', types: ['INT'] },
          { name: 'Decoration', types: ['UINT'] },
          { name: 'LineVariant', types: ['UINT'] },
          { name: 'Level', types: ['INT'] },
          { name: 'Sichtbarkeit', types: ['BOOL'] },
          { name: 'AktionErlaubt', types: ['BOOL'] },
          { name: 'LineFlags', types: ['UINT'] },
        ]},
      ]},
    ],
  }, {
    name: 'PostButtonPressed',
    value: 3,
    parameter: [
      { name: 'ButtonType', types: ['UINT'], example: 5 },
    ],
    response: [],
  }, {
    name: 'PerformAction',
    value: 4,
    parameter: [
      { name: 'AllLineIndex', types: ['UINT'], example: 110 },
    ],
    response: [],
  }, {
    name: 'SetBedienercode',
    value: 5,
    parameter: [
      { name: 'Code', types: ['UINT'], example: 262 },
    ],
    response: [],
  }, {
    name: 'GetValueDescriptor',
    value: 6,
    parameter: [
      { name: 'ValueId', types: ['UINT'], example: 1 },
      { name: 'SkipRanges', types: ['BOOL'], example: false },
    ],
    response: [
      { name: 'Aktueller Value', types: ['INT']},
      { name: 'Minimum', types: ['INT']},
      { name: 'Maximum', types: ['INT']},
      { name: 'FinestQuant', types: ['INT']},
      { name: 'Wertebereichsgruppen', types: ['Array'], children: [
        { name: 'Gruppe', types: ['Array'], children: [
          { name: 'Unterer Einstellwert', types: ['INT']},
          { name: 'Oberer Einstellwert', types: ['INT']},
        ]},
      ]},
      { name: 'SelectedValueId', types: ['INT']},
      { name: 'MinimumContraintId', types: ['INT']},
      { name: 'MaximumContraintId', types: ['INT']},
    ],
  }, {
    name: 'DisplayValue',
    value: 7,
    parameter: [
      { name: 'ValueIndex', types: ['UINT'], example: 1 },
      { name: 'Value', types: ['INT'], example: 1 },
      { name: 'Flags', types: ['UINT'], example: 0 },
    ],
    response: [
      { name: 'Formatierter Text', types: ['String'] },
    ],
  }, {
    name: 'SetValue',
    value: 8,
    parameter: [
      { name: 'ValueIndex', types: ['UINT'], example: 219 },
      { name: 'Value', types: ['INT', 'ByteArray'], example: 1},
    ],
    response: [],
  }, {
    name: 'Confirm',
    value: 9,
    parameter: [
      { name: 'ConfirmValue', types: ['BOOL'], example: true },
    ],
    response: [],
  }, {
    name: 'GetVirtualMenuLines',
    value: 10,
    parameter: [],
    response: [
      { name: 'Menu-Index', types: ['UINT'] },
      { name: 'Line-Index', types: ['UINT', 'null'] },
      { name: 'Cursor-Index', types: ['UINT'] },
      { name: 'Lines', types: ['Array'], children: [
        { name: 'GruppenNr', types: ['UINT'] },
        { name: 'InstanzNr', types: ['UINT'] },
        { name: 'InstanzTyp', types: ['UINT'] },
        { name: '', types: ['Array'], children: [
          { name: 'Konstant-Text', types: ['String'] },
          { name: 'TextRef-Text', types: ['String'] },
          { name: 'ValueRef-Text', types: ['String'] },
          { name: 'ValueRef-ValueId', types: ['INT'] },
          { name: 'ExtraRef-ValueId', types: ['INT'] },
          { name: 'Decoration', types: ['UINT'] },
          { name: 'LineVariant', types: ['UINT'] },
          { name: 'Level', types: ['INT'] },
          { name: 'Sichtbarkeit', types: ['BOOL'] },
          { name: 'AktionErlaubt', types: ['BOOL'] },
          { name: 'LineFlags', types: ['UINT'] },
        ]},
        { name: 'HasActionHandler', types: ['BOOL'] },
        { name: '', types: ['Array'], children: [] },
      ]},
    ],
  }, {
    name: 'PerformVirtualAction',
    value: 11,
    parameter: [
      { name: 'LineIndex', types: ['UINT'], example: 0 },
    ],
    response: [],
  }, {
    name: 'GetValue',
    value: 12,
    parameter: [
      { name: 'ValueId', types: ['UINT'], example: 0 },
    ],
    response: [
      { name: 'Value', types: ['INT', 'ByteArray']},
    ],
  }, {
    name: 'GetStorageInformation',
    value: 13,
    parameter: [
      { name: 'StorageIndex', types: ['INT'], example: 0 },
    ],
    response: [
      { name: 'PageSize_Bytes', types: ['UINT'] },
      { name: 'TotalCapacity_Bytes', types: ['UINT'] },
    ],
  }, {
    name: 'InvalidateStorage',
    value: 14,
    parameter: [
      { name: 'Index', types: ['INT'], example: 0 },
      { name: 'Offset', types: ['INT'], example: 0 },
    ],
    response: [
      { name: 'MextOffset', types: ['UINT'] },
    ],
  }, {
    name: 'WriteStorage',
    value: 15,
    parameter: [
      { name: 'Index', types: ['INT'], example: 0 },
      { name: 'Offset', types: ['INT'], example: 0 },
      { name: 'Buffer', types: ['ByteArray'], example: 'aabb1122' },
    ],
    response: [],
  }, {
    name: 'PerformReset',
    value: 16,
    parameter: [
      { name: 'Reason', types: ['UINT'], example: 1 },
    ],
    response: [],
  }, {
    name: 'GetRpcVersion',
    value: 17,
    parameter: [],
    response: [
      { name: 'Version', types: ['UINT'] },
      { name: 'Changeset ', types: ['UINT'] },
      { name: 'Customization-ID', types: ['UINT', 'null'] },
      { name: 'Applikations-spezifische ID', types: ['UINT'] },
    ],
  }, {
    name: 'ReadEventBuffer',
    value: 18,
    parameter: [
      { name: 'Offset', types: ['UINT'], example: 0 },
    ],
    response: [
      { name: 'Event-Buffer-Offset', types: ['UINT'] },
      { name: 'Buffer', types: ['ByteArray'] },
    ],
  }, {
    name: 'TransmitUart',
    value: 19,
    parameter: [
      { name: 'UartIndex', types: ['INT'], example: 0 },
      { name: 'Buffer', types: ['ByteArray'], example: 'aa11' },
    ],
    response: [
      { name: 'TransmitLength', types: ['UINT'] },
    ],
  }, {
    name: 'ReportReset',
    value: 20,
    parameter: [
      { name: 'Reason', types: ['INT'], example: 0 },
    ],
    response: [],
  }, {
    name: 'TransmitOnionParameters',
    value: 21,
    parameter: [
      { name: 'IP-Address-eth0', types: ['String'], example: '196.123.34.45' },
      { name: 'MAC-Address-eth0', types: ['String'], example: '123456789abc' },
      { name: 'IP-Address-wifi', types: ['String'], example: '-' },
      { name: 'MAC-Address-wifi', types: ['String'], example: '000000000000' },
      { name: 'VBusNet-Token', types: ['String'], example: 'abx' },
      { name: 'SoftwareVersion', types: ['UINT'], example: 256 },
      { name: 'Timestamp', types: ['UINT'], example: 1234566 },
      { name: 'Artikelnummer', types: ['UINT'], example: 111111111 },
    ],
    response: [],
  }, {
    name: 'SetUpdateHeaderStartOffset',
    value: 22,
    parameter: [
      { name: 'StartOffset', types: ['UINT'] },
    ],
    response: [],
  }, {
    name: 'PerformUpdate',
    value: 23,
    parameter: [],
    response: [],
  },
];

const OnionRpcEvents = [
  { name: 'RESOL_ONION_RPC_EVENTID_UART_RX', shortName: 'UART_RX', value: 1 },
  { name: 'RESOL_ONION_RPC_EVENTID_RESET_ONION_TO_DEFAULTS', shortName: 'RESET_ONION_TO_DEFAULTS', value: 2 },
  { name: 'RESOL_ONION_RPC_EVENTID_BOOTUP_NOTIFICATION', shortName: 'BOOTUP_NOTIFICATION', value: 3 },
  { name: 'RESOL_ONION_RPC_EVENTID_START_UPDATE_NOTIFICATION', shortName: 'START_UPDATE_NOTIFICATION', value: 4 },
  { name: 'RESOL_ONION_RPC_EVENTID_PERFORMUPDATE_FAILED', shortName: 'PERFORMUPDATE_FAILED', value: 5 },
  { name: 'RESOL_ONION_RPC_EVENTID_CANCEL_PARAMETERIZATION_SESSION', shortName: 'CANCEL_PARAMETERIZATION_SESSION', value: 6 },
  { name: 'RESOL_ONION_RPC_EVENTID_HEARTBEAT', shortName: 'HEARTBEAT', value: 7 },
];


function onionRpcGetMethodById(methodId) {
  let methodObj = null;
  if (typeof methodId === 'number') {
    methodObj = OnionRpcMethods.find(x => x.value === methodId);
  } else if (typeof methodId === 'string') {
    methodObj = OnionRpcMethods.find(x => x.name === methodId);
  } else if (typeof methodId === 'object'
      && methodId.name && methodId.value
      && methodId.response && Array.isArray(methodId.response)) {
    methodObj = methodId;
  }
  return methodObj;
}


// --------------------------------------------------------------------------------------------------------------
// Ab hier alt
// --------------------------------------------------------------------------------------------------------------

function parseEventBufferToHTML(element, value, globalState) {
  const retEl = [];
  retEl.push('<ul>');

  if (!globalState.eventBufferState) {
    globalState.eventBufferState = {
      remainingEventBuffer: Buffer.alloc(0),
    };
  }
  const state = globalState.eventBufferState;
  const data = Buffer.concat([ state.remainingEventBuffer, value ]);
  
  let rxIndex = 0, rxStart = -1, rxNull = 0;
  while (rxIndex < data.length) {
    if (data[rxIndex] === 0) {
      rxNull = rxIndex;
      if (rxStart >= 0) {
        let cobsMessage = data.subarray(rxStart, rxIndex);
        if (cobsMessage.length > 0) {
          const messageBuffer = cobs.decode(cobsMessage);
          let message = null;
          try {
            message = cbor.decodeAllSync(messageBuffer);
          } catch(e) {
            throw new Error(`CBor decode error "${e.message}" while parsing message: "${Buffer.from(messageBuffer).toString('hex')}"`);
          }
          if (message) {
            const eventId = message[0][0];
            const payload = message[0][1];
            const onionRpcEvent = OnionRpcEvents.find(x => x.value === eventId);

            retEl.push('<li>');
            if (onionRpcEvent) {
              switch(onionRpcEvent.name) {
                case 'RESOL_ONION_RPC_EVENTID_UART_RX': {
                    const rxData = payload[1];
                    retEl.push(`${onionRpcEvent.shortName}[${payload[0]}] = ${rxData.toString('hex')}`);
                  }
                  break;
                case 'RESOL_ONION_RPC_EVENTID_RESET_ONION_TO_DEFAULTS': {
                    const magic = payload[0];
                    retEl.push(`${onionRpcEvent.shortName} = 0x${magic.toString(16)}`);
                  }
                  break;
                case 'RESOL_ONION_RPC_EVENTID_BOOTUP_NOTIFICATION': {
                    const changeset = payload[0];
                    retEl.push(`${onionRpcEvent.shortName} = 0x${changeset.toString(16)} (${changeset})`);
                  }
                  break;
                case 'RESOL_ONION_RPC_EVENTID_START_UPDATE_NOTIFICATION': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_PERFORMUPDATE_FAILED': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_CANCEL_PARAMETERIZATION_SESSION': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_HEARTBEAT':
                    retEl.push(`${onionRpcEvent.shortName}`);
                    break;
                default:
                  retEl.push(`${onionRpcEvent.shortName} = ${typeof payload === 'object' ? payload.toString('hex') : payload.toString()}`);
                  break;
              }
            } else {
              console.log('received unknown event', eventId, payload);
              retEl.push(`Id: ${eventId} = ${payload.toString('hex')}`);
            }
            retEl.push('</li>');
          }
        }
      }
      rxStart = rxIndex + 1;
    }
    rxIndex += 1;
  }
  retEl.push('</ul>');
  state.remainingEventBuffer = Buffer.from(data.subarray(rxNull));

  return retEl;
}


function parseElementsToHTML(element, value) {
  // console.log(`parseElementsToHTML(${JSON.stringify(element)}, ${JSON.stringify(value)})`);
  const retEl = [];
  retEl.push('<li>');
  if (value == null) {
    if (element.types.includes('null')) {
      retEl.push(`${element.name} = null`);
    } else {
      retEl.push(`${element.name} = INVALID Value 'null'`);
    }
  } else if (typeof value === 'number') {
    if (element.types.includes('INT') || element.types.includes('UINT')) {
      retEl.push(`${element.name} = ${value}`);
    }
  } else if (typeof value === 'string') {
    if (element.types.includes('String')) {
      retEl.push(`${element.name} = ${value}`);
    }
  } else if (typeof value === 'boolean') {
    if (element.types.includes('BOOL')) {
      retEl.push(`${element.name} = ${value ? 'Ja' : 'Nein'}`);
    }
  } else if (typeof value === 'object') {
    if (element.types.includes('ByteArray')) {
      const valueStr = value.toString('hex');
      if (valueStr.length > 128) {
        retEl.push('<table><tr>');
        retEl.push(`<td>${element.name} = ... </td><td></td>`);
        let strPos = 0;
        while (strPos < valueStr.length) {
          const len = Math.min(valueStr.length - strPos, 128);
          retEl.push(`<tr><td>idx ${strPos / 2}..${(strPos + len) / 2 - 1}</td><td>${valueStr.substring(strPos, strPos + len)}</td></tr>`);
          strPos += len;
        }
        retEl.push('</tr></table>');
      } else {
        retEl.push(`${element.name} = ${valueStr}`);
      }
    } else if (Array.isArray(value) && element.children) {
      retEl.push('<ul>');
      retEl.push(`${element.name}`);
      for (let i = 0; i < element.children.length; i += 1) {
        const childResponse = element.children[0].types.includes('Array') ? element.children[0] : element.children[i];
        const childValue = value[i];
        const childRetEl = parseElementsToHTML(childResponse, childValue);
        retEl.push(childRetEl.flat(3).join(''));
      }
      retEl.push('</ul>');
    }
  } else {
    console.log(`OnionRpcElement: Unknown value type ${typeof value}, expect one of ${element.types.join(', ')}`);
  }
  retEl.push('</li>');
  return retEl;
}

function onionRpcRequestToHTML(methodId, parameterData, state) {
  const method = onionRpcGetMethodById(methodId);
  const retStr = [];

  if (method != null) {
    retStr.push('<ul>');
    for (let i = 0; i < parameterData.length; i += 1) {
      const parameter = method.parameter[0].types.includes('Array') ? method.parameter[0] : method.parameter[i];
      const value = parameterData[i];
      let retEl = [];
      if (method.name === 'ReadEventBuffer' && parameter.name === 'Buffer') {
        retEl = parseEventBufferToHTML(parameter, value, state);
      } else {
        retEl = parseElementsToHTML(parameter, value, state);
      }
      retStr.push(retEl.flat(3).join(''));
    }
    retStr.push('</ul>');
  }

  return retStr.flat(3).join('');
}


function onionRpcResponseToHTML(methodId, responseData, state) {
  const method = onionRpcGetMethodById(methodId);
  const retStr = [];

  if (method != null) {
    retStr.push('<ul>');
    for (let i = 0; i < responseData.length; i += 1) {
      const response = method.response[0].types.includes('Array') ? method.response[0] : method.response[i];
      const value = responseData[i];
      let retEl = [];
      if (method.name === 'ReadEventBuffer' && response.name === 'Buffer') {
        retEl = parseEventBufferToHTML(response, value, state);
      } else {
        retEl = parseElementsToHTML(response, value, state);
      }
      retStr.push(retEl.flat(3).join(''));
    }
    retStr.push('</ul>');
  }
  return retStr.flat(3).join('');
}



// --------------------------------------------------------------------------------------------------------------
// Ab hier neu
// --------------------------------------------------------------------------------------------------------------

function parseEventBufferToObj(element, value, globalState) {
  const retObj = {};
  retObj.events = [];

  if (!globalState.eventBufferState) {
    globalState.eventBufferState = {
      remainingEventBuffer: Buffer.alloc(0),
    };
  }
  const state = globalState.eventBufferState;
  const data = Buffer.concat([ state.remainingEventBuffer, value ]);
  
  let rxIndex = 0, rxStart = -1, rxNull = 0;
  while (rxIndex < data.length) {
    if (data[rxIndex] === 0) {
      rxNull = rxIndex;
      if (rxStart >= 0) {
        let cobsMessage = data.subarray(rxStart, rxIndex);
        if (cobsMessage.length > 0) {
          const messageBuffer = cobs.decode(cobsMessage);
          let message = null;
          try {
            message = cbor.decodeAllSync(messageBuffer);
          } catch(e) {
            throw new Error(`CBor decode error "${e.message}" while parsing message: "${Buffer.from(messageBuffer).toString('hex')}"`);
          }
          if (message) {
            const eventId = message[0][0];
            const payload = message[0][1];
            const onionRpcEvent = OnionRpcEvents.find(x => x.value === eventId);

            const event = {
              onionRpcEvent,
              eventId,
              payload,
              payloadObj: null,
              payloadStr: '',
            };
            if (onionRpcEvent) {
              switch(onionRpcEvent.name) {
                case 'RESOL_ONION_RPC_EVENTID_UART_RX':
                  event.uartIndex = payload[0];
                  event.payloadObj = payload[1];
                  event.payloadStr = event.payload.toString('hex');
                  break;
                case 'RESOL_ONION_RPC_EVENTID_RESET_ONION_TO_DEFAULTS':
                  event.payloadObj = payload[0];
                  event.payloadStr = `0x${event.payload.toString(16)}`;
                  break;
                  case 'RESOL_ONION_RPC_EVENTID_BOOTUP_NOTIFICATION':
                  event.payloadObj = payload[0];
                  event.payloadStr = `0x${event.payloadObj.toString(16)} (${event.payloadObj})}`;
                  break;
                case 'RESOL_ONION_RPC_EVENTID_START_UPDATE_NOTIFICATION': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_PERFORMUPDATE_FAILED': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_CANCEL_PARAMETERIZATION_SESSION': // fallthrough
                case 'RESOL_ONION_RPC_EVENTID_HEARTBEAT':
                    // No payload
                    break;
                default:
                  event.payloadObj = payload;
                  event.payloadStr = `${typeof payload === 'object' ? payload.toString('hex') : payload.toString()}`;
                  break;
              }
            } else {
              console.log('received unknown event', eventId, payload);
              event.onionRpcEvent = {
                value: eventId,
                name: 'Unknown event / Unbekanntes Event',
                shortName: 'Unknown event / Unbekanntes Event',
              };
              event.payloadObj = payload;
              event.payloadStr = payload.toString('hex');
            }
            retObj.events.push(event);
          }
        }
      }
      rxStart = rxIndex + 1;
    }
    rxIndex += 1;
  }
  state.remainingEventBuffer = Buffer.from(data.subarray(rxNull));

  return retObj;
}

function parseElementsToObj(element, value) {
  // console.log(`parseElementsToHTML(${JSON.stringify(element)}, ${JSON.stringify(value)})`);
  const retObj = {
    name: element.name,
    value,
    valueStr: '',
  };
  if (value == null) {
    if (element.types.includes('null')) {
      retObj.valueStr = 'null';
    } else {
      retObj.valueStr = 'INVALID Value \'null\'';
    }
  } else if (typeof value === 'number') {
    if (element.types.includes('INT') || element.types.includes('UINT')) {
      retObj.valueStr = value.toString();
    }
  } else if (typeof value === 'string') {
    if (element.types.includes('String')) {
      retObj.valueStr = value;
    }
  } else if (typeof value === 'boolean') {
    if (element.types.includes('BOOL')) {
      retObj.valueStr = value ? 'Ja' : 'Nein';
    }
  } else if (typeof value === 'object') {
    if (element.types.includes('ByteArray')) {
      retObj.valueStr = value.toString('hex');
    } else if (Array.isArray(value) && element.children) {
      retObj.children = [];
      for (let i = 0; i < element.children.length; i += 1) {
        const childResponse = element.children[0].types.includes('Array') ? element.children[0] : element.children[i];
        const childValue = value[i];
        const childRetEl = parseElementsToObj(childResponse, childValue);
        retObj.children.push(childRetEl);
      }
    }
  } else {
    console.log(`OnionRpcElement: Unknown value type ${typeof value}, expect one of ${element.types.join(', ')}`);
  }
  return retObj;
}

function onionRpcRequestToObj(methodId, parameterData, state) {
  const method = onionRpcGetMethodById(methodId);
  const retObj = {
    elements: [],
  };

  if (method != null) {
    for (let i = 0; i < parameterData.length; i += 1) {
      const parameter = method.parameter[0].types.includes('Array') ? method.parameter[0] : method.parameter[i];
      const value = parameterData[i];
      let retEl = {};
      if (method.name === 'ReadEventBuffer' && parameter.name === 'Buffer') {
        retEl.events = parseEventBufferToObj(parameter, value, state);
      } else {
        retEl.elements = parseElementsToObj(parameter, value, state);
      }
      retObj.elements.push(retEl);
    }
  }

  return retObj;
}

function onionRpcResponseToObj(methodId, responseData, state) {
  const method = onionRpcGetMethodById(methodId);
  const retObj = {
    elements: [],
  };

  if (method != null) {
    for (let i = 0; i < responseData.length; i += 1) {
      const response = method.response[0].types.includes('Array') ? method.response[0] : method.response[i];
      const value = responseData[i];
      let retEl = {};
      if (method.name === 'ReadEventBuffer' && response.name === 'Buffer') {
        retEl.events = parseEventBufferToObj(response, value, state).events;
      } else {
        retEl.elements = parseElementsToObj(response, value, state);
      }
      retObj.elements.push(retEl);
    }
  }
  return retObj;
}

export {
  OnionRpcEvents,
  OnionRpcMethods,

  onionRpcRequestToObj,
  onionRpcResponseToObj,

  onionRpcGetMethodById,
  onionRpcRequestToHTML,
  onionRpcResponseToHTML,
};
